module.exports = __webpack_public_path__ + "static/prodimage3-139c2f55a0efcac48059b09eb0dab075.jpg";